import { DonutGraphWrapper } from './wrapper';
import { DonutGraphKnobs } from './knobs';
import { PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { propertyHierarchy } from 'widgets/endpoints';
import { filterProperties } from 'utilities/srsUtils';
import { DefaultChartColorScales } from 'styles/chartColors';

const flags = [SrsPropertyFlag.Categorical];

export const config = {
	key: 'DONUT_GRAPH',
	label: 'Donut Graph',
	icon: 'doughnut-chart',
	wrapper: DonutGraphWrapper,
	endpoint: propertyHierarchy,
	Knobs: DonutGraphKnobs,
	flags: flags,
	createDefaultOptions: (filteredProperties) => {
		return {
			options: {
				propertyList: [filteredProperties[0].name],
				parameters: {
					maxRoot: 50,
				},
			},
		};
	},
	createDefaultConfiguration: (_filteredProperties) => {
		return {
			colorScale: DefaultChartColorScales.Categorical,
		};
	},
	isValid: (selectedDefinitionName) => {
		return filterProperties(selectedDefinitionName, flags).length >= 1;
	},
};
